export default __webpack_public_path__ + "static/media/knowaste_screenshot.a0a89aba.png";